import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TaskbarService implements OnDestroy{
    TaskbarPaneSubject = new Subject<boolean>();
    ShowPane: boolean = false;


    constructor() { }

    ngOnDestroy() {
      this.TaskbarPaneSubject.next();
      this.TaskbarPaneSubject.complete();
      this.TaskbarPaneSubject.unsubscribe();
    }
}
